import domReady from '@roots/sage/client/dom-ready';
import "@lottiefiles/lottie-player";
import {header} from "@scripts/modules/header.js";
import {mobilemenu} from "@scripts/modules/menu.js";
import {intro} from "@scripts/modules/intro.js";
import {accordion} from "@scripts/modules/accordion.js";
import {slider} from "@scripts/modules/slider.js";
import {scrollDown} from "@scripts/modules/scrollDown.js";
import {musicHero, songsSingleProduct} from "@scripts/modules/music.js";
import {musicContentProduct} from "@scripts/modules/music.js";
import {singleProductSample} from "@scripts/modules/music.js";

import {scrollAnimations} from "@scripts/modules/scrollAnimations.js";
import {bubbles} from "@scripts/modules/bubbles.js";

/**
 * Application entrypoint
 */
domReady(async() => {
  // ...

    let popupShown = localStorage.getItem('popupShown');

    let pageLoadType = performance.navigation.type;

    if (!popupShown || pageLoadType === performance.navigation.TYPE_RELOAD) {
        intro();
        localStorage.setItem('popupShown', 'true');
    }

    header()
    mobilemenu()
    accordion()
    slider()
    scrollDown()
    bubbles()
    musicHero()
    scrollAnimations()
    musicContentProduct()
    singleProductSample()

	// const mainImageWrapper = document.querySelector(".main-image-wrapper");
	// const mainImage = mainImageWrapper.querySelector("img");
	//
	// document.querySelectorAll(".gallery-thumbnails-wrapper a").forEach(function (thumb) {
	// 	thumb.addEventListener("click", function(e) {
	// 		e.preventDefault();
	//
	// 		const img = this.querySelector("img");
	// 		if (!img || !mainImage) return;
	//
	// 		// großes Bild
	// 		const largeImage = img.dataset.large_image;
	//
	// 		if (largeImage) {
	// 			mainImage.src = largeImage;
	//
	// 			// srcset des großen Bildes, falls vorhanden
	// 			if (img.dataset.large_image_srcset) {
	// 				mainImage.srcset = img.dataset.large_image_srcset;
	// 			} else {
	// 				mainImage.removeAttribute("srcset");
	// 			}
	//
	// 			// width/height Attribute entfernen, damit keine Thumbnails gezoomt werden
	// 			mainImage.removeAttribute("width");
	// 			mainImage.removeAttribute("height");
	// 		}
	// 	});
	// });

});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) {
    import.meta.webpackHot.accept(console.error);
}
